import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { AppTranslate } from "./plugins/translate";
import VueCookies from "vue-cookies";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import VueTelInput from "vue-tel-input";
import VueGtag from "vue-gtag";

import VueHtmlToPaper from "vue-html-to-paper";
import { abilitiesPlugin } from "@casl/vue";
import { Ability } from "@casl/ability";
import { Can } from "@casl/vue";
import * as VueGoogleMaps from "vue2-google-maps";
import "./registerServiceWorker";
import { setupUserAbilities } from "@/services/ability";
import VueDragscroll from "vue-dragscroll";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import VueApexCharts from "vue-apexcharts";
import Tooltip from "vue-directive-tooltip";
import Veu from "vue";

import {
  Button,
  Input,
  Link,
  Footer,
  Feedback,
  Icon,
  FIcon,
  LabelingInput,
  AirTable,
  AirTableCell,
  AppDrawer,
  PhoneGroup,
  AddressCard,
  Tags,
  AppDialog,
  Menu,
  TagsGroup,
  Filter,
  Alert,
  Toast,
  AutoComplete,
  NavBar,
  AsideNavBar,
  LimitedText,
  TBody,
  AppWrapper,
  InputTime,
  Panel,
  WindowPanel,
  AppLoader,
  Datetime,
  FilterActions,
  Chart,
  Widget,
  AppTooltip,
  ThreeDots,
  BaseSwitch,
  ImageUploader,
  InputColor,
  AutoCompleteApi,
  AppTimepicker,
  FilterForm,
} from "@/components";

import { OrderStatus, Integration } from "@/directives";
import { Errors } from "@/services/errors";

const ability = new Ability();

Vue.use(Toast);
Vue.use(Alert);
Vue.use(abilitiesPlugin, ability);
Vue.use(VueHtmlToPaper, {});
Vue.use(VueDragscroll);
Vue.use(VueTelInput);
Vue.use(VueCookies);
Vue.use(AppTranslate);
Vue.use(VueApexCharts);
Vue.use(Tooltip);

Veu.directive("order-status", OrderStatus);
Veu.directive("integration", Integration);

Vue.component("ImageUploader", ImageUploader);
Vue.component("AppTooltip", AppTooltip);
Vue.component("Widget", Widget);
Vue.component("Chart", Chart);
Vue.component("APEXChart", VueApexCharts);
Vue.component("Datetime", Datetime);
Vue.component("VueCropper", VueCropper);
Vue.component("AppLoader", AppLoader);
Vue.component("InputTime", InputTime);
Vue.component("WindowPanel", WindowPanel);
Vue.component("Panel", Panel);
Vue.component("AppWrapper", AppWrapper);
Vue.component("NavBar", NavBar);
Vue.component("AsideNavBar", AsideNavBar);
Vue.component("TBody", TBody);
Vue.component("Menu", Menu);
Vue.component("Tags", Tags);
Vue.component("TagsGroup", TagsGroup);
Vue.component("LimitedText", LimitedText);
Vue.component("Can", Can);
Vue.component("Icon", Icon);
Vue.component("FIcon", FIcon);
Vue.component("Button", Button);
Vue.component("Input", Input);
Vue.component("Link", Link);
Vue.component("Footer", Footer);
Vue.component("AppDialog", AppDialog);
Vue.component("Feedback", Feedback);
Vue.component("AirTable", AirTable);
Vue.component("LabelingInput", LabelingInput);
Vue.component("AppDrawer", AppDrawer);
Vue.component("AirTableCell", AirTableCell);
Vue.component("PhoneGroup", PhoneGroup);
Vue.component("AddressCard", AddressCard);
Vue.component("AppFilter", Filter);
Vue.component("FilterActions", FilterActions);
Vue.component("AutoComplete", AutoComplete);
Vue.component("ThreeDots", ThreeDots);
Vue.component("BaseSwitch", BaseSwitch);
Vue.component("InputColor", InputColor);
Vue.component("AutoCompleteApi", AutoCompleteApi);
Vue.component("AppTimepicker", AppTimepicker);
Vue.component("FilterForm", FilterForm);

Vue.use(
  VueGtag,
  {
    config: {
      id: process.env.VUE_APP_GTM_CONFIG_KEY,
      params: {
        send_page_view: true,
      },
      enabled: true,
    },

    appName: "Dashboard V3",
    pageTrackerScreenviewEnabled: false,

    pageTrackerTemplate(to) {
      return {
        page_title: to?.name || "",
        page_path: to?.path || "",
      };
    },
  },
  router
);
//https://matteo-gabriele.gitbook.io/vue-gtag/

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: "places, localContext, geometry",
  },
  installComponents: true,
});

Vue.use(VuetifyGoogleAutocomplete, {
  vueGoogleMapsCompatibility: true,
});

Vue.config.productionTip = true;
Vue.config.performance = true;

Vue.mixin({
  methods: {
    log: (message, ...reset) => {
      console.log(message, ...reset);
    },
  },
  data: function () {
    return {
      get global() {
        return {
          test: "value-test",
        };
      },
    };
  },
});

Vue.config.errorHandler = (err, vm, info) => {
  console.log("App error message: ", err, vm, info);
};

Vue.config.warnHandler = (err, vm, info) => {
  console.warn("App warning message: ", err, vm, info);
};

/**
 * Handle On Debug Env
 * @return {void}
 */
const OnDebug = () => {
  console.log(
    "%c Debug Mode!",
    "color: red; font-family: sans-serif; font-size: 5.5em; font-weight: bolder; text-shadow: #000 1px 1px;"
  );
};

/**
 * Handle On Prod Env
 * @return {void}
 */
const OnProd = () => {
  console.clear();
  console.log(
    "%c Stop!",
    "color: red; font-family: sans-serif; font-size: 5.5em; font-weight: bolder; text-shadow: #000 1px 1px;"
  );
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
};

const onAppMounted = () => {
  /**
   * Call Sentry Errors Module
   */
  new Errors(Vue);

  if (process.env.VUE_APP_IS_DEBUG === "true") {
    return OnDebug();
  }

  OnProd();
};

const MainVue = new Vue({
  mounted() {
    onAppMounted();
    setupUserAbilities();
    window["store"] = store;
  },
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

export default MainVue;
